import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function TeacherDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'overview' | 'students' | 'exams' | 'analytics'>('overview');
  const [selectedExam, setSelectedExam] = useState<number | null>(null);

  const activeExams = [
    {
      id: 1,
      course: 'الرياضيات المتقدمة',
      activeStudents: 24,
      totalStudents: 30,
      startTime: '10:00 صباحاً',
      endTime: '11:00 صباحاً',
      status: 'جاري',
      color: 'bg-blue-500',
      icon: 'ri-calculator-line'
    },
    {
      id: 2,
      course: 'الفيزياء الحديثة',
      activeStudents: 18,
      totalStudents: 25,
      startTime: '11:30 صباحاً',
      endTime: '1:00 مساءً',
      status: 'جاري',
      color: 'bg-purple-500',
      icon: 'ri-atom-line'
    }
  ];

  const studentsProgress = [
    {
      id: 1,
      name: 'أحمد محمد علي',
      avatar: 'https://public.readdy.ai/ai/img_res/949d30a5ee73d521358b7dbdb8450fb5.jpg',
      examsTaken: 12,
      averageScore: 87,
      lastExam: 'الرياضيات المتقدمة',
      lastScore: 92,
      trend: 'up',
      status: 'ممتاز'
    },
    {
      id: 2,
      name: 'فاطمة حسن إبراهيم',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20student%20portrait%20with%20clean%20simple%20background%20academic%20setting%20confident%20expression&width=100&height=100&seq=student2&orientation=squarish',
      examsTaken: 11,
      averageScore: 78,
      lastExam: 'الفيزياء الحديثة',
      lastScore: 82,
      trend: 'up',
      status: 'جيد جداً'
    },
    {
      id: 3,
      name: 'محمد عبدالله سالم',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20student%20portrait%20with%20clean%20simple%20background%20academic%20setting%20focused%20expression&width=100&height=100&seq=student3&orientation=squarish',
      examsTaken: 10,
      averageScore: 65,
      lastExam: 'الكيمياء العضوية',
      lastScore: 58,
      trend: 'down',
      status: 'مقبول'
    },
    {
      id: 4,
      name: 'سارة أحمد خالد',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20student%20portrait%20with%20clean%20simple%20background%20academic%20setting%20bright%20expression&width=100&height=100&seq=student4&orientation=squarish',
      examsTaken: 12,
      averageScore: 94,
      lastExam: 'الرياضيات المتقدمة',
      lastScore: 98,
      trend: 'up',
      status: 'ممتاز'
    },
    {
      id: 5,
      name: 'خالد يوسف محمود',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20student%20portrait%20with%20clean%20simple%20background%20academic%20setting%20serious%20expression&width=100&height=100&seq=student5&orientation=squarish',
      examsTaken: 9,
      averageScore: 71,
      lastExam: 'الأحياء الجزيئي',
      lastScore: 75,
      trend: 'up',
      status: 'جيد'
    }
  ];

  const examAnalytics = [
    {
      id: 1,
      course: 'الرياضيات المتقدمة',
      totalAttempts: 30,
      averageScore: 76,
      passRate: 83,
      difficultQuestions: [
        { question: 'السؤال 15: التفاضل والتكامل', wrongAnswers: 18, percentage: 60 },
        { question: 'السؤال 22: المعادلات التفاضلية', wrongAnswers: 15, percentage: 50 },
        { question: 'السؤال 8: الجبر الخطي', wrongAnswers: 12, percentage: 40 }
      ]
    },
    {
      id: 2,
      course: 'الفيزياء الحديثة',
      totalAttempts: 25,
      averageScore: 72,
      passRate: 76,
      difficultQuestions: [
        { question: 'السؤال 12: الميكانيكا الكمية', wrongAnswers: 16, percentage: 64 },
        { question: 'السؤال 28: النظرية النسبية', wrongAnswers: 14, percentage: 56 },
        { question: 'السؤال 5: الديناميكا الحرارية', wrongAnswers: 11, percentage: 44 }
      ]
    }
  ];

  const upcomingExams = [
    {
      id: 3,
      course: 'الكيمياء العضوية',
      scheduledDate: '2024-02-20',
      scheduledTime: '10:00 صباحاً',
      duration: 75,
      students: 28,
      status: 'مجدول'
    },
    {
      id: 4,
      course: 'علم الأحياء الجزيئي',
      scheduledDate: '2024-02-22',
      scheduledTime: '11:00 صباحاً',
      duration: 60,
      students: 32,
      status: 'مجدول'
    }
  ];

  const handleExamControl = (examId: number, action: 'start' | 'stop' | 'pause') => {
    console.log(`${action} exam ${examId}`);
    // هنا يتم التحكم في الاختبار
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'ممتاز': return 'text-green-600 bg-green-50';
      case 'جيد جداً': return 'text-blue-600 bg-blue-50';
      case 'جيد': return 'text-teal-600 bg-teal-50';
      case 'مقبول': return 'text-yellow-600 bg-yellow-50';
      default: return 'text-slate-600 bg-slate-50';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-[#0F2A3A] mb-3">لوحة التحكم - عضو هيئة التدريس</h1>
              <p className="text-slate-600 text-lg">متابعة وإدارة الاختبارات والطلاب</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="px-4 py-2 bg-white rounded-xl shadow-md">
                <div className="flex items-center gap-2">
                  <i className="ri-calendar-line text-[#1ABC9C] text-xl"></i>
                  <span className="text-sm text-slate-600">اليوم: 15 فبراير 2024</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl">
                <i className="ri-user-line text-2xl text-blue-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">156</span>
            </div>
            <h3 className="text-slate-600 font-semibold">إجمالي الطلاب</h3>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl">
                <i className="ri-file-list-3-line text-2xl text-green-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">42</span>
            </div>
            <h3 className="text-slate-600 font-semibold">اختبار نشط</h3>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-xl">
                <i className="ri-bar-chart-box-line text-2xl text-purple-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">78%</span>
            </div>
            <h3 className="text-slate-600 font-semibold">معدل النجاح</h3>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                <i className="ri-trophy-line text-2xl text-teal-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">82</span>
            </div>
            <h3 className="text-slate-600 font-semibold">متوسط الدرجات</h3>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-2xl shadow-lg p-2 mb-8 inline-flex gap-2">
          <button
            onClick={() => setActiveTab('overview')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'overview'
                ? 'bg-[#1ABC9C] text-white'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-dashboard-line ml-2"></i>
            نظرة عامة
          </button>
          <button
            onClick={() => setActiveTab('students')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'students'
                ? 'bg-[#1ABC9C] text-white'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-user-line ml-2"></i>
            تقدم الطلاب
          </button>
          <button
            onClick={() => setActiveTab('exams')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'exams'
                ? 'bg-[#1ABC9C] text-white'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-file-list-3-line ml-2"></i>
            إدارة الاختبارات
          </button>
          <button
            onClick={() => setActiveTab('analytics')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'analytics'
                ? 'bg-[#1ABC9C] text-white'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-line-chart-line ml-2"></i>
            التحليلات
          </button>
        </div>

        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="grid md:grid-cols-2 gap-8">
            {/* Active Exams */}
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-4">الاختبارات الجارية</h2>
              {activeExams.map(exam => (
                <div key={exam.id} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className={`${exam.color} p-6 text-white`}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                        <i className={`${exam.icon} text-2xl`}></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold">{exam.course}</h3>
                        <p className="text-white/80 text-sm">{exam.startTime} - {exam.endTime}</p>
                      </div>
                      <span className="px-3 py-1 bg-white/20 rounded-full text-sm font-semibold animate-pulse">
                        {exam.status}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                      <i className="ri-user-line"></i>
                      <span>{exam.activeStudents} من {exam.totalStudents} طالب نشط</span>
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm text-slate-600">نسبة المشاركة</span>
                        <span className="text-sm font-bold text-[#0F2A3A]">
                          {Math.round((exam.activeStudents / exam.totalStudents) * 100)}%
                        </span>
                      </div>
                      <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-[#1ABC9C] rounded-full transition-all"
                          style={{ width: `${(exam.activeStudents / exam.totalStudents) * 100}%` }}
                        ></div>
                      </div>
                    </div>

                    <div className="flex gap-3">
                      <button
                        onClick={() => handleExamControl(exam.id, 'pause')}
                        className="flex-1 py-3 bg-yellow-500 text-white font-semibold rounded-xl hover:bg-yellow-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-pause-circle-line ml-2"></i>
                        إيقاف مؤقت
                      </button>
                      <button
                        onClick={() => handleExamControl(exam.id, 'stop')}
                        className="flex-1 py-3 bg-red-500 text-white font-semibold rounded-xl hover:bg-red-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-stop-circle-line ml-2"></i>
                        إنهاء
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Upcoming Exams */}
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-4">الاختبارات القادمة</h2>
              {upcomingExams.map(exam => (
                <div key={exam.id} className="bg-white rounded-2xl shadow-lg p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-[#0F2A3A] mb-2">{exam.course}</h3>
                      <div className="flex items-center gap-4 text-sm text-slate-600">
                        <div className="flex items-center gap-2">
                          <i className="ri-calendar-line text-[#1ABC9C]"></i>
                          <span>{exam.scheduledDate}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-time-line text-[#1ABC9C]"></i>
                          <span>{exam.scheduledTime}</span>
                        </div>
                      </div>
                    </div>
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                      {exam.status}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="p-3 bg-slate-50 rounded-xl">
                      <p className="text-xs text-slate-600 mb-1">المدة</p>
                      <p className="font-bold text-[#0F2A3A]">{exam.duration} دقيقة</p>
                    </div>
                    <div className="p-3 bg-slate-50 rounded-xl">
                      <p className="text-xs text-slate-600 mb-1">عدد الطلاب</p>
                      <p className="font-bold text-[#0F2A3A]">{exam.students} طالب</p>
                    </div>
                  </div>

                  <button
                    onClick={() => handleExamControl(exam.id, 'start')}
                    className="w-full py-3 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-play-circle-line ml-2"></i>
                    بدء الاختبار
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Students Progress Tab */}
        {activeTab === 'students' && (
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="p-6 border-b border-slate-200">
              <h2 className="text-2xl font-bold text-[#0F2A3A]">تقدم الطلاب</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="px-6 py-4 text-right text-sm font-bold text-slate-700">الطالب</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">الاختبارات</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">المعدل</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">آخر اختبار</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">الدرجة</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">الاتجاه</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-slate-700">الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  {studentsProgress.map((student, index) => (
                    <tr key={student.id} className={`border-b border-slate-100 hover:bg-slate-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`}>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <img
                            src={student.avatar}
                            alt={student.name}
                            className="w-10 h-10 rounded-full object-cover"
                          />
                          <span className="font-semibold text-[#0F2A3A]">{student.name}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="font-bold text-slate-700">{student.examsTaken}</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="font-bold text-[#1ABC9C]">{student.averageScore}%</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="text-sm text-slate-600">{student.lastExam}</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="font-bold text-slate-700">{student.lastScore}%</span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <div className="flex items-center justify-center">
                          {student.trend === 'up' ? (
                            <i className="ri-arrow-up-line text-2xl text-green-600"></i>
                          ) : (
                            <i className="ri-arrow-down-line text-2xl text-red-600"></i>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(student.status)}`}>
                          {student.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Exams Management Tab */}
        {activeTab === 'exams' && (
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">إدارة الاختبارات</h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                {[...activeExams, ...upcomingExams].map(exam => (
                  <div key={exam.id} className="border-2 border-slate-200 rounded-2xl p-6 hover:border-[#1ABC9C] transition-all">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="text-xl font-bold text-[#0F2A3A] mb-2">{exam.course}</h3>
                        {'startTime' in exam && (
                          <p className="text-sm text-slate-600">{exam.startTime} - {exam.endTime}</p>
                        )}
                        {'scheduledDate' in exam && (
                          <p className="text-sm text-slate-600">{exam.scheduledDate} - {exam.scheduledTime}</p>
                        )}
                      </div>
                      <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        exam.status === 'جاري' ? 'bg-green-100 text-green-700 animate-pulse' : 'bg-blue-100 text-blue-700'
                      }`}>
                        {exam.status}
                      </span>
                    </div>

                    <div className="grid grid-cols-2 gap-3 mb-4">
                      {'activeStudents' in exam && (
                        <>
                          <div className="p-3 bg-slate-50 rounded-xl">
                            <p className="text-xs text-slate-600 mb-1">الطلاب النشطون</p>
                            <p className="font-bold text-[#0F2A3A]">{exam.activeStudents}/{exam.totalStudents}</p>
                          </div>
                        </>
                      )}
                      {'students' in exam && (
                        <>
                          <div className="p-3 bg-slate-50 rounded-xl">
                            <p className="text-xs text-slate-600 mb-1">عدد الطلاب</p>
                            <p className="font-bold text-[#0F2A3A]">{exam.students}</p>
                          </div>
                          <div className="p-3 bg-slate-50 rounded-xl">
                            <p className="text-xs text-slate-600 mb-1">المدة</p>
                            <p className="font-bold text-[#0F2A3A]">{exam.duration} دقيقة</p>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="flex gap-3">
                      {exam.status === 'جاري' ? (
                        <>
                          <button
                            onClick={() => handleExamControl(exam.id, 'pause')}
                            className="flex-1 py-2 bg-yellow-500 text-white font-semibold rounded-lg hover:bg-yellow-600 transition-all whitespace-nowrap cursor-pointer text-sm"
                          >
                            <i className="ri-pause-line ml-1"></i>
                            إيقاف
                          </button>
                          <button
                            onClick={() => handleExamControl(exam.id, 'stop')}
                            className="flex-1 py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition-all whitespace-nowrap cursor-pointer text-sm"
                          >
                            <i className="ri-stop-line ml-1"></i>
                            إنهاء
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleExamControl(exam.id, 'start')}
                          className="w-full py-2 bg-[#1ABC9C] text-white font-semibold rounded-lg hover:bg-[#16a085] transition-all whitespace-nowrap cursor-pointer text-sm"
                        >
                          <i className="ri-play-line ml-1"></i>
                          بدء الاختبار
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Analytics Tab */}
        {activeTab === 'analytics' && (
          <div className="space-y-6">
            {examAnalytics.map(exam => (
              <div key={exam.id} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="p-6 bg-gradient-to-r from-[#0F2A3A] to-[#1a3d52] text-white">
                  <h3 className="text-2xl font-bold mb-2">{exam.course}</h3>
                  <div className="flex items-center gap-6 text-sm">
                    <div className="flex items-center gap-2">
                      <i className="ri-user-line"></i>
                      <span>{exam.totalAttempts} محاولة</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-bar-chart-line"></i>
                      <span>متوسط: {exam.averageScore}%</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-trophy-line"></i>
                      <span>نسبة النجاح: {exam.passRate}%</span>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-xl font-bold text-[#0F2A3A] mb-4">الأسئلة الأكثر صعوبة</h4>
                  <div className="space-y-4">
                    {exam.difficultQuestions.map((q, index) => (
                      <div key={index} className="border-2 border-slate-200 rounded-xl p-4">
                        <div className="flex items-start justify-between mb-3">
                          <div className="flex-1">
                            <p className="font-semibold text-[#0F2A3A] mb-1">{q.question}</p>
                            <p className="text-sm text-slate-600">
                              {q.wrongAnswers} من {exam.totalAttempts} طالب أخطأ في هذا السؤال
                            </p>
                          </div>
                          <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-bold">
                            {q.percentage}%
                          </span>
                        </div>
                        <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-red-500 rounded-full transition-all"
                            style={{ width: `${q.percentage}%` }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-xl">
                    <div className="flex items-start gap-3">
                      <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
                      <div>
                        <h5 className="font-bold text-blue-900 mb-1">توصية تعليمية</h5>
                        <p className="text-sm text-blue-800">
                          يُنصح بمراجعة هذه المواضيع مع الطلاب وتقديم شرح إضافي أو أمثلة تطبيقية لتحسين الفهم.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
